"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CDNUrlCreator = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _config = require("./config");

var defualtEnv = 'product';

var CDNUrlCreator = /*#__PURE__*/function () {
  function CDNUrlCreator(env) {
    (0, _classCallCheck2["default"])(this, CDNUrlCreator);
    (0, _defineProperty2["default"])(this, "env", defualtEnv);
    this.env = env;
  }

  (0, _createClass2["default"])(CDNUrlCreator, [{
    key: "createPathByKey",
    value: function createPathByKey(key) {
      var currentDir = 'assets';
      var finalDir = "".concat(currentDir, "/static/upload");
      var path = "".concat(finalDir, "/configuration/").concat(this.env.toLowerCase(), "/").concat(key.toLowerCase(), ".json");
      return path;
    }
  }, {
    key: "getFullPathByKeyAndCdn",
    value: function getFullPathByKeyAndCdn(key, cdn) {
      var path = this.createPathByKey(key);
      var cdnHost = (0, _config.addProtocol)(_config.cdnConfigs[cdn].host);
      var wholePath = "".concat(cdnHost, "/").concat(path);
      return wholePath;
    }
  }]);
  return CDNUrlCreator;
}();

exports.CDNUrlCreator = CDNUrlCreator;